/**
 * Created by anatoly on 20.08.2026
 */

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_CELL] = {
    model: CellBooster,
    type: cleverapps.Boosters.TYPES.CHEAP,
    limit: AdsLimits.TYPES.BOOSTER_1,
    icon_moving: bundles.game.frames.cellbooster_moving_png,
    icon: bundles.game.frames.cellbooster_png,
    icon_active: bundles.game.frames.cellbooster_active_png,
    available: cleverapps.config.availables.CELL_BOOSTER
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_LINE] = {
    model: LineBooster,
    type: cleverapps.Boosters.TYPES.MEDIUM,
    limit: AdsLimits.TYPES.BOOSTER_2,
    icon_moving: bundles.game.frames.linebooster_moving_png,
    icon: bundles.game.frames.linebooster_png,
    icon_active: bundles.game.frames.linebooster_active_png,
    available: cleverapps.config.availables.LINE_BOOSTER
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_COLOR] = {
    model: ColorBooster,
    type: cleverapps.Boosters.TYPES.EXPENSIVE,
    limit: AdsLimits.TYPES.BOOSTER_3,
    icon_moving: bundles.game.frames.colorbooster_moving_png,
    icon: bundles.game.frames.colorbooster_png,
    icon_active: bundles.game.frames.colorbooster_active_png,
    available: cleverapps.config.availables.COLOR_BOOSTER
};
